import cloneDeep from 'lodash/cloneDeep';
import type { LevelData } from '../game/level/LevelData';
import { EditMode } from './types';
import { DEFAULT_LEVEL_DATA, MAX_HISTORY_LENGTH } from './constants';

export interface EditorHistoryState {
  levelData: LevelData;
  editMode: EditMode;
}

export class EditorHistoryManager {
  static #instance: EditorHistoryManager;

  private readonly history: EditorHistoryState[] = [
    {
      levelData: cloneDeep(DEFAULT_LEVEL_DATA),
      editMode: EditMode.Default,
    },
  ];

  public static get instance(): EditorHistoryManager {
    if (!this.#instance) this.#instance = new EditorHistoryManager();
    return this.#instance;
  }

  public addState(undoState: EditorHistoryState): void {
    const { history } = this;
    history.push(undoState);
    if (history.length > MAX_HISTORY_LENGTH) history.shift();
  }

  public getLastState(): EditorHistoryState | undefined {
    return this.history.at(-1);
  }

  public removeLastState(): EditorHistoryState | undefined {
    return this.history.pop();
  }
}
